import { Link, BottomNavigation, Typography, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { SupportUsButton } from './donations';
import { NavPages, NavUtils } from 'utils';


interface Props {
    isEventContext?: boolean;
    absoluteBottom?: boolean;
}

export const AppFooter = ({ isEventContext = false, absoluteBottom = true }: Props) => {
    return (
        <BottomNavigation className={`app-footer ${absoluteBottom ? 'absolute-bottom' : ''}`}>
            <Paper className="footer-content" sx={{ boxShadow: 'none', border: 'none', transition: 'none' }}>
                {isEventContext && (
                    <Typography variant="body1">
                        powered by{' '}
                        <Link component={RouterLink} to={NavUtils.generateNavPath(NavPages.Root)}>
                            Avron Quizzes
                        </Link>
                    </Typography>
                )}
                <SupportUsButton />
            </Paper>
        </BottomNavigation>
    );
};